import React from "react";
import { Layout } from "antd";
import Sidebar from "./Sidebar";
import HeaderBar from "./HeaderBar";
import { Outlet } from "react-router-dom";

const { Content } = Layout;

const AccountLayout = () => {
    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sidebar />
            <Layout>
                <HeaderBar />
                <Content style={{ margin: "16px" }}>
                    <div style={{ padding: 24, background: "#fff", borderRadius: 10 }}>
                        <Outlet />
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
};

export default AccountLayout;